// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.color_code_enum_5bdcd50c */
var ColorCodeEnum5bdcd50c;
(function (ColorCodeEnum5bdcd50c) {
    ColorCodeEnum5bdcd50c["Yellow"] = "Yellow";
    ColorCodeEnum5bdcd50c["Green"] = "Green";
    ColorCodeEnum5bdcd50c["Red"] = "Red";
    ColorCodeEnum5bdcd50c["Blue"] = "Blue";
    ColorCodeEnum5bdcd50c["Pink"] = "Pink";
    ColorCodeEnum5bdcd50c["Brown"] = "Brown";
    ColorCodeEnum5bdcd50c["Purple"] = "Purple";
    ColorCodeEnum5bdcd50c["Orange"] = "Orange";
})(ColorCodeEnum5bdcd50c || (ColorCodeEnum5bdcd50c = {}));
;
export default ColorCodeEnum5bdcd50c;
/** Zod schema for color_code_enum_5bdcd50c */
export const colorCodeEnum5bdcd50c = z.nativeEnum(ColorCodeEnum5bdcd50c);
//# sourceMappingURL=ColorCodeEnum5bdcd50c.js.map